import { render, staticRenderFns } from "./PeopleAvatar.vue?vue&type=template&id=be351bf6&scoped=true&"
import script from "./PeopleAvatar.vue?vue&type=script&lang=js&"
export * from "./PeopleAvatar.vue?vue&type=script&lang=js&"
import style0 from "./PeopleAvatar.vue?vue&type=style&index=0&id=be351bf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be351bf6",
  null
  
)

export default component.exports